function initAffiliateButtons() {
  document.querySelectorAll('product-form-component').forEach((form) => {
    const productId = form.dataset.productId;
    const affiliateData = document.querySelector(
      `[data-affiliate-product-id="${productId}"]`
    );
    if (!affiliateData) return;

    const affiliateLink = affiliateData.dataset.affiliateLink;
    const affiliateText = affiliateData.dataset.affiliateText || 'Jetzt ansehen';

    const buttons = form.querySelector('[ref="productFormButtons"]');
    if (!buttons) return;

    buttons.innerHTML = `
      <a
        href="${affiliateLink}"
        target="_blank"
        rel="nofollow sponsored"
        class="button add-to-cart-button"
        style="width:100%; text-align:center;"
      >${affiliateText}</a>
    `;
  });
}

// Beim Laden und nach jedem DOM-Update
document.addEventListener('DOMContentLoaded', initAffiliateButtons);
const observer = new MutationObserver(initAffiliateButtons);
observer.observe(document.body, { childList: true, subtree: true });
